import { supabase } from './supabase';

export async function submitPaymentRequest({ gymId, periodMonths, senderName, note }) {
  const { data, error } = await supabase.rpc('submit_payment_request', {
    p_gym_id: gymId,
    p_period_months: periodMonths,
    p_sender_name: senderName,
    p_note: note || null,
  });
  return { data, error };
}

export async function getMyPaymentRequests(gymId) {
  const { data, error } = await supabase
    .from('payment_requests')
    .select('*')
    .eq('gym_id', gymId)
    .order('created_at', { ascending: false })
    .limit(10);
  if (error) return [];
  return data || [];
}
